import React, { useEffect, useRef, useState } from "react";
import { confirmAlert } from 'react-confirm-alert';
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
import trau from "../assets/img/ic-bantin.png";
import { resetRedux } from "../redux/Actions";
import { actions } from "../redux/authRedux";
import parse from 'html-react-parser'

const _ = require('lodash');
//904832009
export default function SiderBar() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { countcv } = useSelector((state) => state.save);
    const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
    const location = useLocation();
    let localsegment = location.pathname;
    const submenuRef = useRef(null);
    const [showSubMenu, setShowSubmenu] = useState(null);

    let listMenus = [
        // { title: 'Bảng tin', icon: 'flaticon-dashboard', link: '/bang-tin' },
        { title: 'Báo cáo công việc', icon: 'fas fa-chart-line', link: '/baocaocongviec' },
        {
            title: 'Dịch vụ hành chính', icon: 'dv-hc-icon.png', link: '', active: ['/van-thu', '/vanthu_param', '/phan-cong-cap-so', '/dat-xe', '/dat-phong-hop', '/quan-ly-xe', '/quan-ly-phong-hop', 'bao-cao-xe-phong-hop'].includes(localsegment), children: [
                { title: 'Văn thư lưu trữ', icon: 'vanthu.png', link: '/van-thu' },
                { title: 'Phân loại văn thư', icon: 'loai-vanthu.png', link: '/vanthu_param' },
                { title: 'Phân công cấp số', icon: 'capsovanthu.png', link: '/phan-cong-cap-so' },
                { title: 'Đặt xe', icon: 'datxe.png', link: '/dat-xe' },
                { title: 'Đặt phòng họp', icon: 'datphonghop.png', link: '/dat-phong-hop' },
                { title: 'Quản lý xe', icon: 'quanlyxe.png', link: '/quan-ly-xe' },
                { title: 'Quản lý phòng họp', icon: 'quanlyroom.png', link: '/quan-ly-phong-hop' },

            ]
        },
        {
            title: 'Tờ trình', icon: 'workfollow.png', link: '', active: ['/workflow_type', '/workflow_walking'].includes(localsegment), children: [
                { title: 'Phân loại tờ trình', icon: 'loai-vanthu.png', link: '/workflow_type' },
                { title: 'Danh sách tờ trình', icon: 'totrinh.png', link: '/workflow_walking' },
            ]
        },
        {
            title: 'Learning Hub', icon: 'learning-hub.png', link: '', active: ['/learning_profile_manager', '/khoa-hoc', '/learninghub-profile', '/learninghub_baigiang'].includes(localsegment), children: [
                { title: 'Profile', icon: 'profile.png', link: '/learninghub-profile' },
                { title: 'Khóa học', icon: 'khoahoc.png', link: '/khoa-hoc' },
                { title: 'Quản lý Profile', icon: 'profile.png', link: '/learning_profile_manager' },
                { title: 'Quản lý Bài Giảng', icon: 'learning-hub.png', link: '/learninghub_baigiang' },
            ]
        },
        {
            title: 'Dịch vụ công nghệ', icon: 'technical-support.png', link: '', active: ['/quan-ly-qrcode', '/may-cham-cong', '/checkin', '/blue-form'].includes(localsegment), children: [
                { title: 'Tạo QRcode', icon: 'qrcode.png', link: '/quan-ly-qrcode' },
                { title: 'Quản lý máy chấm công', icon: 'calendar.png', link: '/may-cham-cong' },
                { title: 'Quản lý Checkin', icon: 'checklist.png', link: '/checkin' },
                // { title: 'Blue Form', icon: 'fas fa-angle-right', link: '/blue-form' },
            ]
        },
        {
            title: 'Văn hóa - Truyền thông', icon: 'truyenthong-vanhoa.png', link: '', active: ['/calendar', '/quan-ly-sticker'].includes(localsegment), children: [
                { title: 'Sự kiện', icon: 'sukien.png', link: '/calendar' },
                { title: 'Quản lý Sticker', icon: 'listemoji.png', link: '/quan-ly-sticker' },
            ]
        },
        {
            title: 'Đăng ký - Giải trình', icon: 'register.png', link: '', active: ['/list-users-break', '/list-giaitrinh'].includes(localsegment), children: [
                { title: 'Đăng ký chấm công', icon: 'dangkycc.png', link: '/list-users-break' },
                // { title: 'Đăng ký đi làm ngày lễ/Cuối tuần', icon: 'fas fa-angle-right', link: '/dang-ky-lam-le' },
                { title: 'Giải trình chấm công', icon: 'giaitrinh.png', link: '/list-giaitrinh' },
            ]
        },
        {
            title: 'Duyệt đăng ký <br/> Giải trình công', icon: 'customer-service.png', link: '', active: ['/list-approve-break', 'list-duyet-giai-trinh'].includes(localsegment), children: [
                { title: 'Duyệt đăng ký chấm công', icon: 'checklist.png', link: '/list-approve-break' },
                // { title: 'Phê duyệt Đăng ký đi làm ngày lễ/Cuối tuần', icon: 'fas fa-angle-right', link: '/duyet-dang-ky-lam-le' },
                { title: 'Duyệt giải trình chấm công', icon: 'assessment.png', link: '/list-duyet-giai-trinh' },
            ]
        },
        {
            title: 'Bảng chấm công', icon: 'calendar.png', link: '', active: ['/list-users_onday', '/list-cham-cong-thang', '/upload-chamcong-bpmax', '/bangchotcongthang'].includes(localsegment), children: [
                { title: 'Bảng chấm công chi tiết', icon: 'totrinh.png', link: '/list-users_onday' },
                { title: 'Bảng chấm công tháng', icon: 'calendar.png', link: '/list-cham-cong-thang' },
                { title: 'Bảng chốt công tháng', icon: 'calendar.png', link: '/bangchotcongthang' },
                // { title: 'Upload chấm công BPMAX', icon: 'fas fa-angle-right', link: '/upload-chamcong-bpmax' },
            ]
        },

        {
            title: 'Quản trị nhân sự', icon: 'personal-information.png', link: '', active: ['/list-users', '/users_gitiho', '/list-thuc-tap-sinh', '/users_login', '/link-ung-vien'].includes(localsegment), children: [
                { title: 'Danh sách nhân sự', icon: 'quanlyroom.png', link: '/list-users' },
                { title: 'Danh sách thực tập sinh', icon: 'ttsuser.png', link: '/list-thuc-tap-sinh' },
                { title: 'Danh sách ứng viên', icon: 'ungvien.png', link: '/users_new' },
                { title: 'Link ứng viên', icon: 'linkuv.png', link: '/link-ung-vien' },
                { title: 'Tân tuyển', icon: 'tantuyen.png', link: '/tan-tuyen' },
                // { title: 'Quản lý tài khoản Gitiho', icon: 'fas fa-angle-right', link: '/users_gitiho' },
                { title: 'Theo dõi đăng nhập', icon: 'userlogin.png', link: '/users_login' },
                // { title: 'Mẫu hợp đồng', icon: 'fas fa-angle-right', link: '/mau-hop-dong' },
                // { title: 'Hợp đồng', icon: 'fas fa-angle-right', link: '/hop-dong' },
            ]
        },

        {
            title: 'Cẩm nang nội bộ', icon: 'classification.png', link: '', active: ['/danh-muc-tin', '/danh-sach-tin'].includes(localsegment), children: [
                { title: 'Danh mục', icon: 'categories.png', link: '/danh-muc-tin' },
                { title: 'Danh sách cẩm nang', icon: 'handbook.png', link: '/danh-sach-tin' },
            ]
        },
        {
            title: 'Cài đặt tổ chức', icon: 'team-work.png', link: '', active: ['/list-parts', '/lambu', '/vanthu_param', '/capbac', '/list-chucvu', '/list-company', '/list-users_onday_settings', 'cai-dat-nhan-su'].includes(localsegment), children: [
                { title: 'Công ty thành viên', icon: 'company.png', link: '/list-company' },
                { title: 'Phòng ban', icon: 'department.png', link: '/list-parts' },
                { title: 'Danh sách chức vụ', icon: 'capsovanthu.png', link: '/list-chucvu' },
                { title: 'Danh sách cấp bậc', icon: 'next-level.png', link: '/capbac' },
                // { title: 'Ca làm việc', icon: 'fas fa-angle-right', link: '/list-ca-lam' },
                { title: 'Quản lý ca làm', icon: 'efficiency.png', link: '/quan-ly-ca' },
                { title: 'Phân ca làm', icon: 'time-management.png', link: '/phan-ca-lam' },
                { title: 'Cài đặt nhân sự', icon: 'authorization.png', link: '/cai-dat-nhan-su' },
                { title: 'Ngày lễ, ngày nghỉ, NVP', icon: 'handbook.png', link: '/ngay-le' },
                { title: 'Quản lý ngày làm bù', icon: 'lambu.png', link: '/lambu' },
            ]
        },
        {
            title: 'Báo cáo', icon: 'baocao.png', link: '', active: ['/bao-cao-xe-phong-hop', '/bao-cao-nhan-su'].includes(localsegment), children: [
                { title: 'Báo cáo DV hành chính', icon: 'baocaohc.png', link: '/bao-cao-xe-phong-hop' },
                { title: 'Báo cáo nhân sự', icon: 'baocaonhansu.png', link: '/bao-cao-nhan-su' },
            ]
        },
        {
            title: 'Cài đặt hệ thống', icon: 'system-administration.png', link: '', active: ['/list-settings', '/test-email', '/danh-sach-gui-mail', '/quan-ly-sticker'].includes(localsegment), children: [
                { title: 'Cài đặt thông số', icon: 'caidatthongso.png', link: '/list-settings' },
                { title: 'Phân quyền', icon: 'authorization.png', link: '/list-roles' },
                { title: 'Test gửi mail', icon: 'emailsetting.png', link: '/test-email' },
                { title: 'Danh sách gửi mail', icon: 'send-data.png', link: '/danh-sach-gui-mail' },

            ]
        },
    ];

    const checkRole = (idparent, menu) => {
        let isrole = false;
        let id = menu.id;
        if (!id) id = _.trimStart(menu.link, ' /');
        if (id) {
            if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(id) && MyRole[idparent].children[id].checked === true) isrole = true
            else if (MyRole.hasOwnProperty(id) && MyRole[id].checked === true) isrole = true
        } else {
            if (menu.hasOwnProperty('children') && menu.children && menu.children.length > 0) {
                menu.children.map((sub) => {
                    let idsub = _.trimStart(sub.link, ' /');
                    if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(idsub) && MyRole[idparent].children[idsub].checked === true) isrole = true
                    else if (idsub && MyRole.hasOwnProperty(idsub) && MyRole[idsub].checked === true) isrole = true
                    return sub;
                })
            }
        }
        // if(menu.link === '/marktests') console.log(MyRole);
        return isrole
    }
    //Hàm xử lý đăng xuất
    const dologout = () => {
        confirmAlert({
            title: "Đăng xuất",
            message: "Bạn có chắc muốn đăng xuất",
            closeOnEscape: true,
            closeOnClickOutside: true,
            buttons: [
                {
                    label: "Đăng xuất",
                    onClick: () => {
                        dispatch(resetRedux());
                        dispatch(actions.login(null));
                    },
                },
                { label: "Không" },
            ],
        });
    };

    const subMenu = (idparent, list, active) => {
        return <>
            {list && list.length > 0 ? <div className={"submenu-wrapper " + ((showSubMenu && showSubMenu == idparent) ? "open" : "")}>
                <div className="btn-group-close" onClick={() => setShowSubmenu(null)}>
                    <button type="button" className="button-close" >
                        <img
                            src={require(`../assets/img/icon-mybhs/close-icon.png`)}
                            alt="close"
                            className="sidebar-icon"
                        />
                    </button>
                </div>
                <div className={`row sub-group-menu `}>
                    {list.map((item, i) => {
                        let title = item.title
                        let DKchoDuyet = countcv && countcv.DKchoDuyet ? countcv.DKchoDuyet : 0
                        let GTchuaGui = countcv && countcv.GTchuaGui ? countcv.GTchuaGui : 0
                        let DKchuaDuyet = countcv && countcv.DKchuaDuyet ? countcv.DKchuaDuyet : 0
                        let GTchuaDuyet = countcv && countcv.GTchuaDuyet ? countcv.GTchuaDuyet : 0
                        let workflow_waiting = countcv && countcv.workflow_waiting ? countcv.workflow_waiting : []

                        if (title == 'Đăng ký chấm công' && DKchoDuyet > 0) {
                            title = <><span>Đăng ký chấm công</span><span className="sub-sp">{DKchoDuyet}</span></>
                        } else if (title == 'Giải trình chấm công' && GTchuaGui > 0) {
                            title = <><span>Giải trình chấm công</span><span className="sub-sp">{GTchuaGui}</span></>
                        } else if (title == 'Duyệt đăng ký chấm công' && DKchuaDuyet > 0) {
                            title = <><span>Duyệt đăng ký chấm công</span><span className="sub-sp">{DKchuaDuyet}</span></>
                        } else if (title == 'Duyệt giải trình chấm công' && GTchuaDuyet > 0) {
                            title = <><span>Duyệt giải trình chấm công</span><span className="sub-sp">{GTchuaDuyet}</span></>
                        } else if (item.link == '/workflow_walking' && workflow_waiting.length > 0) {
                            title = <><span>{title}</span><span className="sub-sp">{workflow_waiting.length}</span></>
                        } else {
                            title = <span>{title}</span>
                        }
                        if (checkRole(idparent, item)) {
                            return <div className="col-4 nav-item" key={i}>
                                <div className={`nav-link ${item.link === localsegment ? 'menu-active' : ''}`}>
                                    <div className="w-100 d-flex justify-content-center align-items-center">
                                        <a className="icon" href={item.link}>
                                            <img
                                                src={require(`../assets/img/icon-mybhs/${item.icon}`)}
                                                alt={item.title}
                                                className="sidebar-icon"
                                            />
                                        </a>
                                    </div>
                                    <p>{title}</p>
                                </div>
                            </div>
                        } else return null
                    })}
                </div>
            </div > : null
            }
        </>
    }

    return (
        <>
            {/* Sidebar Area Start Here */}
            <div className={"sidebar-main sidebar-menu-one p-0 sidebar-color "}>
                <div className="sidebar-menu-content">
                    <div className="list-menu">
                        <div className={`sidebar-menu-item ` + ('bang-tin' === localsegment ? 'menu-active' : '')}>
                            <div className={`nav-link`}>
                                <div className="w-100 d-flex justify-content-center align-items-center">
                                    <a className="icon" href={"/bang-tin"}>
                                        <img src={trau} className='icon-post' alt='Cộng đồng Blue' />
                                    </a>
                                </div>
                                <p>Cộng đồng Blue</p>
                            </div>
                        </div>

                        {listMenus.map((item, i) => {
                            if (checkRole(null, item) || item.role) {
                                let title = item.title
                                item.id = i + 1
                                let DKchoDuyet = countcv && countcv.DKchoDuyet ? countcv.DKchoDuyet : 0
                                let GTchuaGui = countcv && countcv.GTchuaGui ? countcv.GTchuaGui : 0
                                let DKchuaDuyet = countcv && countcv.DKchuaDuyet ? countcv.DKchuaDuyet : 0
                                let GTchuaDuyet = countcv && countcv.GTchuaDuyet ? countcv.GTchuaDuyet : 0
                                let workflow_waiting = countcv && countcv.workflow_waiting ? countcv.workflow_waiting : []
                                if (title == 'Đăng ký/Giải trình' && (DKchoDuyet + GTchuaGui) > 0) {
                                    title = <><span>Đăng ký</span><span className="sub-sp">{DKchoDuyet}</span><span> - Giải trình</span><span className="sub-sp">{GTchuaGui}</span></>
                                } else if (title == 'Phê duyệt' && (DKchuaDuyet + GTchuaDuyet) > 0) {
                                    title = <><span>Phê duyệt</span><span className="sub-sp">{DKchuaDuyet + GTchuaDuyet}</span></>
                                } else if (title == 'Tờ trình' && (workflow_waiting.length) > 0) {
                                    title = <><span>Tờ trình</span><span className="sub-sp">{workflow_waiting.length}</span></>
                                } else {
                                    title = <span>{parse(title)}</span>
                                }

                                return <div key={i} className={`sidebar-menu-item ${item.children ? 'sidebar-has-children' : ''} `} >
                                    {!item.children ?
                                        <div to={item.link} className={`nav-link`}>
                                            <div className="w-100 d-flex justify-content-center align-items-center">
                                                <a href={item.link} className="icon">
                                                    <img
                                                        src={require(`../assets/img/icon-mybhs/${item.icon}`)}
                                                        alt={item.title}
                                                        className="sidebar-icon"
                                                    />
                                                </a>
                                            </div>
                                            <p>{title}</p>
                                        </div>
                                        :
                                        <div to={item.link} className={`nav-link has-child-menu`} >
                                            <div className="w-100 d-flex justify-content-center align-items-center">
                                                <div className="icon" onClick={() => setShowSubmenu(item.id)}>
                                                    <img
                                                        src={require(`../assets/img/icon-mybhs/${item.icon}`)}
                                                        alt={item.title}
                                                        className="sidebar-icon"
                                                    />
                                                </div>
                                            </div>
                                            <p>{title}</p>
                                        </div>}
                                    {subMenu(item.id, item.children)}
                                </div>
                            } else return null
                        })}
                        <div className="sidebar-menu-item">
                            <div className="nav-link">
                                <div className="w-100 d-flex justify-content-center align-items-center">
                                    <div className="icon" onClick={() => window.location.reload()}>
                                        <img
                                            src={require(`../assets/img/icon-mybhs/refresh.png`)}
                                            alt={"Tải lại trang"}
                                            className="sidebar-icon"
                                        />
                                    </div>
                                </div>
                                <p>Tải lại trang</p>
                            </div>
                        </div>
                        <div className="sidebar-menu-item">
                            <div className="nav-link">
                                <div className="w-100 d-flex justify-content-center align-items-center">
                                    <a className="icon" href="#logout" onClick={dologout}>
                                        <img
                                            src={require(`../assets/img/icon-mybhs/sign-out.png`)}
                                            alt={"Tải lại trang"}
                                            className="sidebar-icon"
                                        />
                                    </a>
                                </div>
                                <p>Đăng xuất</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Sidebar Area End Here */}
        </>
    );
}
